/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_CreateInputs */

const en_landing_nav_create = /** @type {(inputs: Landing_Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Image`)
};

const zh_landing_nav_create = /** @type {(inputs: Landing_Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 生图`)
};

/**
* | output |
* | --- |
* | "AI Image" |
*
* @param {Landing_Nav_CreateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_nav_create = /** @type {((inputs?: Landing_Nav_CreateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_CreateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_create(inputs)
	return zh_landing_nav_create(inputs)
});
export { landing_nav_create as "landing.nav.create" }